import { render } from "./ZBCD.vue?vue&type=template&id=6bce65f5&scoped=true"
import script from "./ZBCD.vue?vue&type=script&lang=js"
export * from "./ZBCD.vue?vue&type=script&lang=js"

import "./ZBCD.vue?vue&type=style&index=0&id=6bce65f5&lang=css"
import "./ZBCD.vue?vue&type=style&index=1&id=6bce65f5&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bce65f5"]])

export default __exports__